// KPI DATA — development fallback when `/executive-pulse/dashboard` is unavailable.
// Same shape as GET /executive-pulse/dashboard (see oracle-backend `executive-pulse-service.js`).

import EXECUTIVE_PULSE_UI_EDITABLE_KPI_IDS from '../config/executive-pulse-ui-editable-kpis.js';
import {
    buildReportingPeriod,
    getCalendarYear,
    reportingPeriodToClientMeta
} from '../utils/executive-pulse-reporting-period.js';

function catalogKpiRow(kpiId, title, target, startDate, endDate) {
    return {
        kpiId,
        title,
        value: null,
        target,
        startDate,
        endDate
    };
}

/**
 * @param {number} year
 * @param {Date} [now]
 */
export function buildMockExecutivePulseDashboard(year, now = new Date()) {
    const period = buildReportingPeriod(year, now);
    const startDate = period.chartStartIso;
    const endDate = period.chartEndIso;

    const pillars = {
        financial: [
            catalogKpiRow(
                'ep-financial-db-consults-1499',
                'DB Consults',
                1499,
                startDate,
                endDate
            ),
            catalogKpiRow(
                'ep-financial-unitas-consults-3701',
                'Unitas Consults',
                3701,
                startDate,
                endDate
            ),
            catalogKpiRow(
                'ep-financial-hsra-500',
                'HSRAs / RAs',
                500,
                startDate,
                endDate
            )
        ],

        customer: [
            catalogKpiRow(
                'ep-customer-qbr-process',
                'QBR process rollout',
                100,
                startDate,
                endDate
            ),
            catalogKpiRow(
                'ep-customer-delivered-practices-80pct',
                'Delivered to practices',
                80,
                startDate,
                endDate
            ),
            catalogKpiRow(
                'ep-customer-digital-100pct',
                '100% digital (QBR)',
                100,
                startDate,
                endDate
            ),
            catalogKpiRow(
                'ep-customer-churn-reduction-10pct',
                'Churn reduction (10% vs baseline)',
                10,
                startDate,
                endDate
            )
        ],

        process: [
            catalogKpiRow(
                'ep-process-copilot-offices-400',
                'Copilot adoption (offices)',
                400,
                startDate,
                endDate
            ),
            catalogKpiRow(
                'ep-process-gross-profit-600k',
                'Gross profit return',
                600,
                startDate,
                endDate
            ),
            catalogKpiRow(
                'ep-process-people-vision-2028',
                'People Vision 2028',
                100,
                startDate,
                endDate
            ),
            catalogKpiRow(
                'ep-process-12-month-plan',
                '12-month plan',
                100,
                startDate,
                endDate
            )
        ],

        growth: [
            catalogKpiRow(
                'ep-growth-1a-q1-2026',
                'Launch 1A',
                100,
                startDate,
                endDate
            ),
            catalogKpiRow(
                'ep-growth-1b-q2-2026',
                'Launch 1B',
                100,
                startDate,
                endDate
            )
        ]
    };

    return {
        ...pillars,
        meta: {
            dataMode: 'offline',
            schemaVersion: 1,
            asOf: now.toISOString(),
            reportingPeriod: reportingPeriodToClientMeta(period),
            uiEditableKpiIds: [...EXECUTIVE_PULSE_UI_EDITABLE_KPI_IDS],
            targetEditableKpiIds: [
                'ep-financial-db-consults-1499',
                'ep-financial-unitas-consults-3701',
                'ep-financial-hsra-500',
                'ep-customer-qbr-process',
                'ep-customer-delivered-practices-80pct',
                'ep-customer-digital-100pct',
                'ep-customer-churn-reduction-10pct',
                'ep-process-copilot-offices-400',
                'ep-process-gross-profit-600k',
                'ep-process-people-vision-2028',
                'ep-process-12-month-plan',
                'ep-growth-1a-q1-2026',
                'ep-growth-1b-q2-2026'
            ],
            hub: {
                status: 'disabled',
                enabled: false,
                detail: 'Development mock — manual-only mode.',
                hubUsedForKpis: []
            },
            manualKpiCount: 0
        }
    };
}

const defaultY = getCalendarYear();

const fallbackKpiData = buildMockExecutivePulseDashboard(defaultY);

export default fallbackKpiData;
